"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
/**
 * This Pipe is to filter arrays with a BYO filter callback.
 *
 */
class SceneFilterPipe {
    constructor() { }
    transform(items, currentScene) {
        if (!items || !currentScene) {
            return items;
        }
        return items.filter(item => item["activeSceneId"] == currentScene.id);
    }
}
exports.SceneFilterPipe = SceneFilterPipe;
